import { render, staticRenderFns } from "./DnsList.vue?vue&type=template&id=5a7dc677&scoped=true"
import script from "./DnsList.vue?vue&type=script&lang=js"
export * from "./DnsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7dc677",
  null
  
)

export default component.exports